import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";
import { Reveal } from "../hooks/useScrollReveal";
import BackToTop from "./BackToTop";

export default function FAQ() {
  const { t } = useI18n();
  const [open, setOpen] = useState(-1);

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="bg-[#f4f0e9] pt-24 md:pt-36 pb-14 md:pb-20"
    >
      <div className="max-w-[960px] mx-auto px-6 md:px-10">
        <Reveal className="text-center">
          <div className="eyebrow-center mb-6" data-testid="faq-eyebrow">{t.faq.eyebrow}</div>
          <h2
            data-testid="faq-title"
            className="font-serif-hero text-[#252525] text-[34px] sm:text-[44px] md:text-[52px] leading-[1.1]"
          >
            {t.faq.title}
          </h2>
          <p className="mt-4 text-[14.5px] text-[#6f6f6a]">{t.faq.subtitle}</p>
        </Reveal>

        <div className="mt-14 space-y-4">
          {t.faq.items.map((item, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={i}>
                <div
                  data-testid={`faq-item-${i}`}
                  className={`bg-[#fdfcf9] border border-[#e6e1d6] rounded-[12px] transition-all duration-500 ${
                    isOpen ? "shadow-[0_20px_60px_-40px_rgba(37,37,37,0.25)]" : ""
                  } relative overflow-hidden`}
                >
                  <div
                    className={`absolute left-0 top-0 bottom-0 w-[3px] bg-[#b86a55] transition-opacity duration-500 ${
                      isOpen ? "opacity-100" : "opacity-40"
                    }`}
                  />
                  <button
                    data-testid={`faq-toggle-${i}`}
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="w-full flex items-center justify-between gap-6 text-left px-6 md:px-8 py-5 md:py-6"
                    aria-expanded={isOpen}
                  >
                    <span className="font-serif text-[19px] md:text-[21px] text-[#252525] leading-snug">
                      {item.q}
                    </span>
                    <span
                      className={`shrink-0 w-8 h-8 rounded-full border border-[#b86a55]/60 flex items-center justify-center transition-transform duration-500 ${
                        isOpen ? "rotate-180" : ""
                      }`}
                    >
                      {isOpen ? (
                        <Minus size={14} strokeWidth={1.5} className="text-[#b86a55]" />
                      ) : (
                        <Plus size={14} strokeWidth={1.5} className="text-[#b86a55]" />
                      )}
                    </span>
                  </button>
                  <div
                    className={`grid transition-all duration-500 ease-in-out ${
                      isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <div className="px-6 md:px-8 pb-6 md:pb-7">
                        <div className="h-px bg-[#e6e1d6] mb-5 w-[72%]" />
                        <p
                          data-testid={`faq-answer-${i}`}
                          className="text-[14.5px] leading-[1.8] text-[#4a4a45]"
                        >
                          {item.a}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>

        <div className="mt-8 md:mt-10">
          <BackToTop testId="back-to-top-faq" />
        </div>
      </div>
    </section>
  );
}
